import React, { useContext, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import './Table.scss';

export const DefaultTableSettings = {
  page: 1,
  sizePerPage: 20,
  sortDir: 1,
};

const paginationStyle = `
background: red,
li {
color: red
}

ul{
color: red;
}
`;

const Table = ({
  keyField,
  data,
  columns,
  onTableChange,
  noDataIndication,
  selectRow,
  rowStyle,
  rowClasses,
  sizePerPage = DefaultTableSettings.sizePerPage,
  page = DefaultTableSettings.page,
  totalSize,
}) => {
  return (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <BootstrapTable
              bootstrap4
              striped
              hover
              remote={true}
              keyField={keyField}
              data={data}
              columns={columns.map(column => ({
                ...column,
                headerStyle: column.headerStyle || { width: column.width },
                style: column.style || { width: column.width },
              }))}
              onTableChange={onTableChange}
              noDataIndication={noDataIndication}
              selectRow={selectRow}
              rowStyle={rowStyle}
              rowClasses={rowClasses}
              {...paginationTableProps}
            />
            {totalSize > 20 && (
              <div>
                <PaginationListStandalone {...paginationProps} />
              </div>
            )}
          </div>
        )}
      </PaginationProvider>
    </div>
  );
};

export default Table;
